module.exports = __webpack_public_path__ + "img/regional-market-icon.f62c3fcd.svg";